import React from 'react'
import styled from 'styled-components'
import { Text, Divider } from '../components/UI'
import { useArea, useParam, useIsPortrait, useIsMobile, useStore } from '../hooks'

const Container = styled.div`
	position: relative;
	height: ${p => p.isPortrait ? '40vh' : '100vh'};
	padding-top: ${p => (p.isPortrait || p.isMobile) ? ' 11.5vh' : '0'};
`

export default function Area(props) {
	const isPortrait = useIsPortrait()
	const isMobile = useIsMobile();
	const [store, dispatch] = useStore()
	const id = useParam('id')
	const components = useArea(id)

	return (
		<Container isPortrait={isPortrait}>
			{ (isPortrait || isMobile) && (
				<>
					<Text center bold H12 style={{height: 'auto'}} >
					{ store?.areas?.[id]?.name || 'Area' }
					</Text>
					<Divider primary width='90vw'/>
				</>
			)}
				
			{components}
		</Container>
	)
}